export default __webpack_public_path__ + "static/media/Public sector.66521684.png";